<template>
  <div class="home-page">
    <img :src="bannerImg" >
    <div class="flex page-content">
      <div class="left">
        <div class="name">
          你好, {{username}}
        </div>
        <div class="bandwidth">
          <div>
            <img src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/home/icon/phone-icon.svg">
            {{phone}}
          </div>
          <div>
            <img src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/home/icon/role-icon.svg">
            {{premission}}
          </div>
        </div>
<!--        <div class="bandwidth">-->
<!--          <div>-->
<!--            <img src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/home/icon/bandwidth.svg">-->
<!--            {{bandwidth}}-->
<!--          </div>-->
<!--        </div>-->
      </div>
     <div class="right">
       <div class="time">
         <time-display theme="elegant" time-format="12" date-format="long" />
       </div>
<!--       <p class="right-p">-->
<!--         {{yiyan}}-->
<!--       </p>-->
     </div>

    </div>
    <div class="box-content">

    </div>
  </div>
</template>
<script>
import axios from 'axios'
//main.js
import * as echarts from 'echarts'
import 'echarts-liquidfill'
import store from "../../store";
// import Img from "@/views/enterprise/enterprise_cert_list/img.vue";
import TimeDisplay from '../../components/time-cpn.vue'
export default {
  name: "homeIndex",
  components: {TimeDisplay},
  computed: {
    store() {
      return store
    }
  },
  data() {
    return {
      bannerImg: "",
      username:"",
      premission:"",
      phone:"",
      yiyan:"",
      bandwidth:'',
      bgList:[
          'https://images.xxapi.cn/images/4k/wallpaper/9502f4ed941b4f62bd2d650510dceddd.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/11b7fa1f7526439699d321b4543ecba8.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/11b7fa1f7526439699d321b4543ecba8.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/ad9056f6721c4ad09ce4a973a2bcda19.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/7598b49d64b44e89a64adfbf40c54428.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/73892ada5f8e41d794cb2b714c4594de.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/520e1731b3de4170810fc73b418e8644.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/83f5f14e55554eed90195e34487f0a35.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/83f5f14e55554eed90195e34487f0a35.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/6eeb64b645d24d229beb7c4b6d0d5b77.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/ad9056f6721c4ad09ce4a973a2bcda19.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/020a1051d89f40bd92ad4ce455860ff5.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/020a1051d89f40bd92ad4ce455860ff5.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/27f9e6bd880511ebb6edd017c2d2eca2.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/c9dcf5747ce24247a8e36377f7aa0c6f.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/6643d0779fb04012bf98aebfe400ded1.jpg',
        'https://images.xxapi.cn/images/4k/wallpaper/6643d0779fb04012bf98aebfe400ded1.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/a77471a9880b11ebb6edd017c2d2eca2.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/83f5f14e55554eed90195e34487f0a35.jpg',
          'https://images.xxapi.cn/images/4k/wallpaper/520e1731b3de4170810fc73b418e8644.jpg',


      ],
      yiyanList:[
          "今天也要做个不加班的打工小王子！",
        "打工不爽？那就打出风采来！",
        "钱虽难赚，但你很棒棒哒！",
        "不怕起早上班，就怕错过发财！",
        "今天也要笑着搬砖哦～",
        "努力到老板害怕你！",
        "咬咬牙，再多赚一个亿！",
        "办公室不是战场，是秀场～",
        "再卷一下，离奖金更近一步！",
        "工作如山，翻了就赢！",
        "今天也要闪闪发光地打工！",
        "办公室精灵已上线～",
        "脑洞一开，灵感就来！",
        "上班如上朝，臣已到位～",
        "打工路上，一起冲鸭！",
        "KPI不怕你多，就怕你不敢冲！",
        "今天也要元气满满搞事业！",
        "头脑风暴暴富，行动开挂人生！。",
        "来了来了，打工魂上线了！",
        "来了来了，打工魂上线了！",
        "来了来了，打工魂上线了！",
        "来了来了，打工魂上线了！",
        "来了来了，打工魂上线了！",
      ]

    }
  },
  mounted(){

  },
  created() {
    this.init()
  },
  methods: {
    init(){
      this.username=this.$cookies.get("username");
      this.phone=this.$cookies.get("phone")
      this.premission=this.$cookies.get("premission")
      // this.getBannerImg()
      this.yiyan=this.yiyanList[Math.floor(Math.random()*20)]
      this.bannerImg=this.bgList[Math.floor(Math.random()*20)]
    },

    /**
     * 获取网速
     */
    getSpeed(){
      const that =this
      var config = {
        method: 'get',
        url: `https://v2.xxapi.cn/api/speed?url=${process.env.VUE_APP_BASE_URL}`
      }
      axios(config)
          .then(function (response) {
            that.bandwidth=response.data.data
          })
          .catch(function (error) {
            console.log(error)

          })
    },
    /**
     * 获取随机背景图
     */
    getBannerImg() {
      const that = this
      var config = {
        method: 'get',
        url: 'https://v2.xxapi.cn/api/random4kPic?type=wallpaper'
      }
      axios(config)
        .then(function (response) {
          that.bannerImg = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>



<style scoped lang="less">
/deep/ .el-main {
  padding: 0px;
}

::v-deep .el-main {
  padding: 0px;
}

.home-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  box-sizing: border-box;
  top: 0px;
  left: 0px;

  &>img {
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
  }
.page-content{
  width: 100%;
  padding: 200px 150px  ;
  box-sizing: border-box;
  position: absolute;
  justify-content: space-between;
}
  .right{
    font-size: 30px;
    width:1000px;
    margin-left: 100px;
    font-weight: 600;
    color: #ffffff;
    white-space: pre-wrap;
    padding-top: 60px;
    p{
      width: 100%;
    }
    z-index: 3;
    .time{
      margin-bottom: 50px;
    }
  }
  .left {

    z-index: 2;
    width: 300px;
    min-height:400px;
    background: linear-gradient(to bottom,rgba(51, 55, 68, 0.32),rgba(255, 255, 255, 0));
    //border: 1px solid #ffffff;
    border-radius: 20px;
    padding: 30px;
    box-sizing: border-box;
    .name{
      font-size: 30px;
      font-weight: 600;
      color: #ffffff;
      border-bottom: 1px dashed #ffffff;
      padding-bottom: 30px;
    }
    .info{
      padding: 30px 0px;
      font-size:18px;
      color: #ffffff;
      border-bottom: 1px dashed #ffffff;
      &>div{
        display: flex;
        align-items: center;
        padding: 5px 0px;
      }
      img{
        margin-right: 10px;
        width: 20px;
        height:20px;
      }
    }
    .bandwidth{
      padding: 30px 0px;
      font-size:18px;
      color: #ffffff;
      &>div{
        display: flex;
        align-items: center;
        padding: 5px 0px;
      }
      img{
        margin-right: 10px;
        width: 20px;
        height:20px;
      }
    }

  }
  .box-content{
    width: 100%;
    height:40%;
    background: linear-gradient(to top,rgba(51, 55, 68, 1),rgba(255, 255, 255, 0));
    //border-top: 1px solid #ffffff;
    z-index: 1;
    position: absolute;
    bottom: 0px;
  }
}
</style>